<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item) && !isSidebarCollapsed"
    class="nav-item has-sub"
    :class="{
      'open': isOpen,
      'disabled': item.disabled,
      'sidebar-group-active': isActive,
    }"
  >
    <b-link
      class="d-flex align-items-center"
      @click="() => updateGroupOpen(!isOpen)"
    >

      <GjIcon :name="item.gjIcon || 'Globe'" />
      <span class="menu-title text-truncate d-flex">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto text-sm font-weight-regular"
        size="sm"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-collapse
      v-model="isOpen"
      class="menu-content"
      tag="ul"
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      >
      </component>
    </b-collapse>
  </li>
  <li
    v-else
    v-b-tooltip.hover.right
    :title="isSidebarCollapsed && !showPopover ? item.title : ''"
    class="collapsed-siderbar-menu"
    :class="{
      'sidebar-group-active': isActive,
    }"
  >
    <a
      :id="`popover-${item.title}`"
      tabindex="0"
      @focus="onFocus"
      @blur="onBlur"
    ><GjIcon :name="item.gjIcon || 'Globe'" /></a>
    <b-popover
      :ref="`popover-${item.title}`"
      :target="`popover-${item.title}`"
      triggers="manual"
      placement="right"
      :show="showPopover"
    >
      <template #default>
        <router-link
          v-for="child in item.children"
          :key="child.title"
          class="d-block py-50 px-25 text-main popover-link"
          :to="{name: child.route, params: { projectId: activeProjectId } }"
        >{{ child.title }}</router-link>
      </template>
    </b-popover>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from 'bootstrap-vue'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'

// Composition Function
import useVerticalNavMenuGroup from './useVerticalNavMenuGroup'
import mixinVerticalNavMenuGroup from './mixinVerticalNavMenuGroup'

export default {
  name: 'VerticalNavMenuGroup',
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPopover: false,
    }
  },
  computed: {
    activeProjectId() {
      return this.$store.getters['projectModule/getActiveProjectId']
    },
    isSidebarCollapsed() {
      return this.$store.state.projectModule.isSidebarCollapsed && this.$store.state.app.windowWidth > 1199
    },
  },
  methods: {
    onFocus() {
      this.showPopover = true
    },
    onBlur() {
      setTimeout(() => {
        this.showPopover = false
      }, 100)
    },
  },
  setup(props) {
    const {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
    } = useVerticalNavMenuGroup(props.item)

    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuGroup } = useAclUtils()

    return {
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuGroup,

      // i18n
      t,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/@core/scss/tokens/theme.scss';

.popover-link:hover {
  color: $dark-primary !important;
}

.popover-link {
  &:hover {
    color: $dark-primary !important;
  }
  &.router-link-exact-active {
    color: $dark-primary !important;
  }
}
</style>
